import { render } from "./CargaPlanillaObs.vue?vue&type=template&id=8fedb5d0&scoped=true"
import script from "./CargaPlanillaObs.vue?vue&type=script&lang=js"
export * from "./CargaPlanillaObs.vue?vue&type=script&lang=js"

import "./CargaPlanillaObs.vue?vue&type=style&index=0&id=8fedb5d0&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fedb5d0"]])

export default __exports__